import React, {
    Component,
} from 'react';

import {
    Waypoint,
} from 'react-waypoint';

import {
    Carousel,
    SectionTitle,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

import AWARD_IMAGE from 'wanderu-assets/images/chiku-blue-english.png';
import HEARTS_IMAGE from 'wanderu-assets/images/chiku-hearts.png';

import {
    generateAppleStoreUrl,
    generateGooglePlayStoreUrl,
} from '../../urls';
import TwoColumnLayout, {
    LeftColumn,
    RightColumn,
} from '../TwoColumnLayout/TwoColumnLayout';
import data from './data';

import styles from './TestimonialsSection.scss';

function Testimonial(props) {
    return (
        <div
            className={styles.testimonial}
            key={props.text}
        >
            <div className={styles.testimonialText}>
                {props.text}
            </div>
            <div className={styles.testimonialName}>
                {props.author}
            </div>
        </div>
    );
}

class TestimonialsSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
        };
    }

    onEnterWaypoint = () => {
        this.setState(() => ({
            visible: true,
        }));
    }

    render() {
        const {
            t,
            className,
            campaign,
        } = this.props;
        const {
            visible,
        } = this.state;
        const imageClass = `${styles.heartsImage} ${visible
            ? styles.visible
            : ''}`;
        const testimonialData = data.map(Testimonial);
        const appleStoreUrl = generateAppleStoreUrl(campaign);
        const googlePlayStoreUrl = generateGooglePlayStoreUrl(campaign);

        return (
            <section
                aria-labelledby="gta-testimonials"
                className={`${styles.container} ${className}`}
                role="region"
            >
                <TwoColumnLayout layoutClassName={styles.testimonialsSection}>
                    <LeftColumn className={styles.leftColumn}>
                        <img
                            alt="accolades"
                            className={styles.awardImage}
                            height="350"
                            src={AWARD_IMAGE}
                            width="345"
                        />
                        <img
                            alt="<3"
                            className={imageClass}
                            height="350"
                            src={HEARTS_IMAGE}
                            width="375"
                        />
                    </LeftColumn>
                    <RightColumn className={styles.rightColumn}>
                        <div className={styles.rightColumnContent}>
                            <SectionTitle
                                className={styles.title}
                                id="gta-testimonials"
                            >
                                {t('From our fans')}
                            </SectionTitle>
                            <Carousel
                                autoAdvanceAfter={10000}
                                className={styles.carousel}
                                autoplay
                                wrap
                            >
                                {testimonialData}
                            </Carousel>
                            <Carousel
                                className={styles.carouselMobile}
                                wrap
                            >
                                {testimonialData}
                            </Carousel>
                            <div className={styles.getTheApp}>
                                <span>
                                    {t('get-the-app')}
                                </span>
                                <a
                                    aria-label={t('apple-phone-icon')}
                                    href={appleStoreUrl}
                                >
                                    <div className={styles.appleIcon} />
                                </a>
                                <a
                                    aria-label={t('android-phone-icon')}
                                    href={googlePlayStoreUrl}
                                >
                                    <div className={styles.androidIcon} />
                                </a>
                            </div>
                        </div>
                    </RightColumn>
                </TwoColumnLayout>
                <Waypoint onEnter={this.onEnterWaypoint} />
            </section>
        );
    }
}

export {
    TestimonialsSection,
};
export default localize(TestimonialsSection, ['t'], 'baseApp');
